import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";

import App from "./App";
import "./index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthProvider } from "./zoopath/store/AuthContext";

ReactGA.initialize([
  { trackingId: "G-PB3XXQNPS9" }, // for zoopath
  { trackingId: "G-5DTYE6JYYE" }, // for subbannaya
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
